import script from "./SystemLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemLayout.vue?vue&type=script&setup=true&lang=js"

import "./SystemLayout.vue?vue&type=style&index=0&id=7e3f1065&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e3f1065"]])

export default __exports__